module.exports = ""


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app.component.css
 ** module id = 35
 ** module chunks = 0
 **/